var cov_ozywtvs91 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/Body.tsx",
      hash = "960410b0a52d04eb9bf70abd52ae82119a929c69",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/Body.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 21
        },
        end: {
          line: 8,
          column: 47
        }
      },
      "1": {
        start: {
          line: 12,
          column: 72
        },
        end: {
          line: 12,
          column: 82
        }
      },
      "2": {
        start: {
          line: 13,
          column: 25
        },
        end: {
          line: 13,
          column: 88
        }
      },
      "3": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 72
        }
      },
      "4": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 15,
          column: 72
        }
      },
      "5": {
        start: {
          line: 17,
          column: 20
        },
        end: {
          line: 17,
          column: 75
        }
      },
      "6": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 29,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 11
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 54
          },
          end: {
            line: 13,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 13,
            column: 54
          },
          end: {
            line: 13,
            column: 61
          }
        }, {
          start: {
            line: 13,
            column: 65
          },
          end: {
            line: 13,
            column: 75
          }
        }],
        line: 13
      },
      "1": {
        loc: {
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 15,
            column: 72
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 15,
            column: 72
          }
        }, {
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 15,
            column: 72
          }
        }],
        line: 15
      },
      "2": {
        loc: {
          start: {
            line: 17,
            column: 20
          },
          end: {
            line: 17,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 17,
            column: 53
          },
          end: {
            line: 17,
            column: 63
          }
        }, {
          start: {
            line: 17,
            column: 66
          },
          end: {
            line: 17,
            column: 75
          }
        }],
        line: 17
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 11
          },
          end: {
            line: 26,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 11
          },
          end: {
            line: 22,
            column: 35
          }
        }, {
          start: {
            line: 23,
            column: 12
          },
          end: {
            line: 25,
            column: 18
          }
        }],
        line: 22
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/Body.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import List from '../AnimationList';
import { cardClass } from './styles';
import { isRTL } from '../config';
var CollapseList = (cov_ozywtvs91.s[0]++, List(['collapse'], 'fast'));

var Body =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Body, _PureComponent);

  var _super = _createSuper2(Body);

  function Body() {
    _classCallCheck(this, Body);

    return _super.apply(this, arguments);
  }

  _createClass(Body, [{
    key: "render",
    value: function render() {
      cov_ozywtvs91.f[0]++;

      var _ref = (cov_ozywtvs91.s[1]++, this.props),
          className = _ref.className,
          collapsed = _ref.collapsed,
          collapsible = _ref.collapsible,
          onCollapse = _ref.onCollapse,
          other = _objectWithoutProperties(_ref, ["className", "collapsed", "collapsible", "onCollapse"]);

      var newClassName = (cov_ozywtvs91.s[2]++, classnames(cardClass('body', (cov_ozywtvs91.b[0][0]++, isRTL()) && (cov_ozywtvs91.b[0][1]++, 'body-rtl')), className));
      cov_ozywtvs91.s[3]++;

      if (!collapsible) {
        cov_ozywtvs91.b[1][0]++;
        cov_ozywtvs91.s[4]++;
        return (
          /*#__PURE__*/
          React.createElement("div", Object.assign({}, other, {
            className: newClassName,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 15,
              columnNumber: 30
            }
          }))
        );
      } else {
        cov_ozywtvs91.b[1][1]++;
      }

      var onClick = (cov_ozywtvs91.s[5]++, typeof collapsed === 'boolean' ? (cov_ozywtvs91.b[2][0]++, onCollapse) : (cov_ozywtvs91.b[2][1]++, undefined));
      cov_ozywtvs91.s[6]++;
      return (
        /*#__PURE__*/
        React.createElement(CollapseList, {
          show: !collapsed,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 19,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, other, {
          className: newClassName,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 20,
            columnNumber: 9
          }
        }), other.children, (cov_ozywtvs91.b[3][0]++, collapsible === 'bottom') && (cov_ozywtvs91.b[3][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: cardClass('foldup'),
          onClick: onClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23,
            columnNumber: 13
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24,
            columnNumber: 15
          }
        })))))
      );
    }
  }]);

  return Body;
}(PureComponent);

export default Body;